import { LRUCache } from "lru-cache";
import * as APITypes from "~/API";
import { MAX_CACHE_ITEMS } from "./property";

export class BuildingLRUCache {
  private static cache: LRUCache<string, APITypes.Building>;

  public static getCacheInstance() {
    if (BuildingLRUCache.cache) {
      return BuildingLRUCache.cache;
    }

    BuildingLRUCache.cache = new LRUCache<string, APITypes.Building>({
      max: MAX_CACHE_ITEMS,
    });
    return {
      success: true,
      data: BuildingLRUCache.cache,
    };
  }

  public static update({
    key,
    value,
  }: {
    key: string;
    value: APITypes.Building;
  }) {
    if (!BuildingLRUCache.cache) {
      BuildingLRUCache.cache = new LRUCache<string, APITypes.Building>({
        max: MAX_CACHE_ITEMS,
      });
    }

    // TODO: handle the result
    const result = BuildingLRUCache.cache.set(key, value);
    return {
      success: true,
      data: BuildingLRUCache.cache,
    };
  }

  /**
   * Clear the entire cache or a single element in the cache
   *
   * @param key optional: the key for the element to be removed from the cache.
   * If not passed, then entire cache is cleared
   * @returns
   */
  public static clear({ key }: { key?: string }) {
    if (!BuildingLRUCache.cache) {
      BuildingLRUCache.cache = new LRUCache<string, APITypes.Building>({
        max: MAX_CACHE_ITEMS,
      });
    }

    if (key) {
      const isDeleted = BuildingLRUCache.cache.delete(key);
      return {
        success: isDeleted,
        data: BuildingLRUCache.cache,
        error: isDeleted
          ? new Error(`error deleting ${key} from the building cache`)
          : null,
      };
    }

    BuildingLRUCache.cache.clear();
    return {
      success: true,
      data: BuildingLRUCache.cache,
    };
  }
}
